export default __webpack_public_path__ + "static/media/WWS-Logo.340fddcf.png";